import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';

export const kymw03Handlers = [

  // 特集コード情報リスト取得 /kymw03/getFeatureCodeList
  http.post(PlessService.SERVICE.KYMW03GetFeatureCodeList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW03GetFeatureCodeList.url, req);
    return HttpResponse.json(getFeatureCodeListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getFeatureCodeListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "FeatureCode": "12345",
        "FeatureName": "特集",
      },
      {
        "FeatureCode": "23456",
        "FeatureName": "特集2",
      },
      {
        "FeatureCode": "34567",
        "FeatureName": "特集3",
      },
    ],
  },
};
